// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"TempHotelResults_iconSync__2GNdc","fa-spin":"TempHotelResults_fa-spin__2IcG1"};